import { Badge } from "flowbite-react";
import { motion, AnimatePresence } from "framer-motion";
import { FaGraduationCap, FaCalendarAlt, FaUniversity, FaEnvelope  } from "react-icons/fa";
import ldcuimage from "../profile/LDCUU.jpg";
import ustpimage from "../profile/USTP.jpg";


function Education() {
  const containerVariants = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    show: { 
      opacity: 1, 
      y: 0,
      transition: {
        duration: 0.5,
        ease: "easeOut"
      }
    }
  };

  const educationData = [
    {
      title: "Senior High School Education",
      institution: "Liceo de Cagayan University (LDCU)",
      period: "2019-2021",
      description: "I completed my Senior High School education at Liceo de Cagayan University (LDCU).",
      image: ldcuimage,
      icon: FaCalendarAlt
    },
    {
      title: "College Education",
      institution: "University of Science and Technology of Southern Philippines",
      period: "2021-Present",
      description: "Pursuing a Bachelor's degree in INFORMATION TECHNOLOGY at University of Science and Technology of Southern Philippines (USTP).",
      image: ustpimage,
      icon: FaUniversity
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#1A1F2C] via-[#222222] to-[#1A1F2C] py-20 px-6 md:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Header Section */}
        <motion.div 
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          className="flex items-center gap-3 mb-16"
        >
          <Badge 
            className="px-4 py-2 text-lg font-mono bg-[#9b87f5]/10 text-[#9b87f5] border-none tracking-wider"
            icon={() => <FaGraduationCap className="mr-2" />}
          >
            EDUCATION
          </Badge>
        </motion.div>

        {/* Education Cards */}
        <AnimatePresence mode="wait">
          <motion.div
            variants={containerVariants}
            initial="hidden"
            animate="show"
            exit="hidden"
            className="grid grid-cols-1 md:grid-cols-2 gap-8"
          >
            {educationData.map((education, index) => (
              <motion.div
                key={index}
                variants={cardVariants}
                className="group relative overflow-hidden rounded-2xl bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm 
                         hover:from-white/15 hover:to-white/10 transition-all duration-500 p-6"
              >
                {/* Education Image */}
                <div className="aspect-video overflow-hidden rounded-xl mb-6">
                  <img 
                    src={education.image} 
                    alt={education.institution}
                    className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-black/0 
                               group-hover:from-black/70 transition-all duration-500" />
                </div>

                {/* Education Info */}
                <div className="space-y-4">
                  <h3 className="tech-heading text-white group-hover:text-[#9b87f5] transition-colors duration-300">
                    {education.title}
                  </h3>
                  <p className="tech-text text-white/70 text-sm leading-relaxed">
                    {education.description}
                  </p>
                  
                  {/* Period */}
                  <div className="flex items-center gap-2 text-white/60">
                    <education.icon className="text-[#9b87f5]" />
                    <span className="font-sf-mono text-sm">{education.period}</span>
                  </div>
                </div>

                {/* Hover Overlay */}
                <div className="absolute inset-0 border-2 border-transparent group-hover:border-[#9b87f5]/50 
                             rounded-2xl transition-all duration-500 pointer-events-none" />
              </motion.div>
            ))}
          </motion.div>
        </AnimatePresence>

        {/* Footer */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
          className="text-center mt-16"
        >
          <p className="tech-label">
            © 2025 ALL RIGHTS RESERVED 
          </p>
        </motion.div>
      </div>
    </div>
  );
}

export default Education;